export function firstName(fullName?: string) {
  return fullName?.split(" ")[0] ?? "";
}
